import { useDispatch } from 'react-redux';
import SharedOvulationUser from './SharedOvulationUser';

function SharedOvulationPredictions({ predictions }) {
  const dispatch = useDispatch();

  if (!predictions?.length) return null;

  return (
    <div className="flex-1 flex flex-col min-h-0">
      <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-primary flex-shrink-0">
        Shared Ovulation Predictions {predictions?.length > 0 && `(${predictions.length})`}
      </p>
      <ul className="flex-1 space-y-2 overflow-y-auto min-h-0">
        {predictions.map((prediction) => (
          <SharedOvulationUser key={prediction.ownerId} prediction={prediction} />
        ))}
      </ul>
    </div>
  );
}

export default SharedOvulationPredictions;
